/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * For the given evidence, specifies the status of processing of the given evidence object.
 */
export const EvidenceStatus = {
    Unprocessed: 1,
    Processed: 2,
    Invalid: 3
} as const;
export type EvidenceStatus = typeof EvidenceStatus[keyof typeof EvidenceStatus];

